var exports = {
  "h": "xf0b3b88a--e27aec--description",
  "z": "xf0b3b88a--e27aec--credentials",
};

module.exports = exports;
